
export default {
    layout: 'empty',
}
